// extracted by mini-css-extract-plugin
module.exports = {"primary":"#0d4f9d","secondary":"#ff1744"};